// 依赖
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/store.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import baseHttp from '@/assets/js/base_http.js'
import Lockr from 'lockr'
import config from '@/assets/js/config.js'
import _g from '@/assets/js/global.js'

// 组件
let Login = (resolve) => require(['@/components/Account/Login.vue'], resolve)
let Register = (resolve) => require(['@/components/Account/Register.vue'], resolve)
let refresh = (resolve) => require(['@/components/refresh.vue'], resolve)
let Lang = (resolve) => require(['@/components/Index/personnel/user/lang.vue'], resolve)
let Home = (resolve) => require(['@/components/Home.vue'], resolve)
let Agreement = (resolve) => require(['@/components/Index/personnel/user/agreement.vue'], resolve)
let indexHome = (resolve) => require(['@/components/Index/personnel/index/home.vue'], resolve)
let indexKefu = (resolve) => require(['@/components/Index/personnel/index/kefu.vue'], resolve)
let myIndex = (resolve) => require(['@/components/Index/personnel/my/index.vue'], resolve)
let orderIndex = (resolve) => require(['@/components/Index/personnel/order/index.vue'], resolve)
let ctrlRecharge = (resolve) => require(['@/components/Index/personnel/ctrl/recharge.vue'], resolve)
let rot_orderIndex = (resolve) => require(['@/components/Index/personnel/rot_order/index.vue'], resolve)
let ctrlTrc20 = (resolve) => require(['@/components/Index/personnel/ctrl/trc20.vue'], resolve)
let myTrc20 = (resolve) => require(['@/components/Index/personnel/my/trc20.vue'], resolve)
let myBind_trc20 = (resolve) => require(['@/components/Index/personnel/my/bind_trc20.vue'], resolve)
let myBind_bank = (resolve) => require(['@/components/Index/personnel/my/bind_bank.vue'], resolve)
let myBind_ban_book = (resolve) => require(['@/components/Index/personnel/my/bind_bank_book.vue'], resolve)
let ctrlUsdt = (resolve) => require(['@/components/Index/personnel/ctrl/usdt.vue'], resolve)
let myYhk = (resolve) => require(['@/components/Index/personnel/my/yhk.vue'], resolve)
let myInvite = (resolve) => require(['@/components/Index/personnel/my/invite.vue'], resolve)
let ctrlEdit_pwd = (resolve) => require(['@/components/Index/personnel/ctrl/edit_pwd.vue'], resolve)
let ctrlEdit_pwd2 = (resolve) => require(['@/components/Index/personnel/ctrl/edit_pwd2.vue'], resolve)
let ctrlJunior = (resolve) => require(['@/components/Index/personnel/ctrl/junior.vue'], resolve)
let ctrlSet = (resolve) => require(['@/components/Index/personnel/ctrl/set.vue'], resolve)
let ctrlRecharge_admin = (resolve) => require(['@/components/Index/personnel/ctrl/recharge_admin.vue'], resolve)
let ctrlDeposit_admin = (resolve) => require(['@/components/Index/personnel/ctrl/deposit_admin.vue'], resolve)
let myCaiwu = (resolve) => require(['@/components/Index/personnel/my/caiwu.vue'], resolve)
let myDetail = (resolve) => require(['@/components/Index/personnel/my/detail.vue'], resolve)
let myWallet = (resolve) => require(['@/components/Index/personnel/my/wallet.vue'], resolve)




Vue.use(VueRouter)

/**
 * meta参数解析
 * hideLeft: 是否隐藏左侧菜单，单页菜单为true
 * module: 菜单所属模块
 * menu: 所属菜单，用于判断三级菜单是否显示高亮，如菜单列表、添加菜单、编辑菜单都是'menu'，用户列表、添加用户、编辑用户都是'user'，如此类推
 */

const routes = [
  { 
    path: '/', 
    component: Login, 
    name: 'Login'
  },
  {
    path: '/admin',
    component: Home,
    children: [
      { path: '/refresh', component: refresh, name: 'refresh' }
    ]
  },
  {
    path: '/index',
    component: Lang,
    children: [
      { path: 'user/lang', component: Lang, name: 'Lang', meta: { hideLeft: false, module: 'user', menu: 'user' }},
    ]
  },
  {
    path: '/index',
    component: Register,
    children: [
      { path: 'user/register', component: Register, name: 'Register', meta: { hideLeft: false, module: 'user', menu: 'user' }} 
    ]
  },
  {
    path: '/index',
    component: Agreement,
    children: [
      { path: 'user/agreement', component: Agreement, name: 'Agreement', meta: { hideLeft: false, module: 'user', menu: 'user' }} 
    ]
  },
  {
    path: '/index',
    component: indexHome,
    children: [
      { path: 'index/home', component: indexHome, name: 'indexHome', meta: { hideLeft: false, module: 'index', menu: 'index' }} 
    ]
  },
  {
    path: '/index',
    component: indexKefu,
    children: [
      { path: 'index/kefu', component: indexKefu, name: 'indexKefu', meta: { hideLeft: false, module: 'index', menu: 'index' }} 
    ]
  },
  {
    path: '/index',
    component: myIndex,
    children: [
      { path: 'my/index', component: myIndex, name: 'myIndex', meta: { hideLeft: false, module: 'my', menu: 'my' }} 
    ]
  },
  {
    path: '/index',
    component: myWallet,
    children: [
      { path: 'my/wallet', component: myWallet, name: 'myWallet', meta: { hideLeft: false, module: 'my', menu: 'my' }} 
    ]
  },
  {
    path: '/index',
    component: orderIndex,
    children: [
      { path: 'order/index', component: orderIndex, name: 'orderIndex', meta: { hideLeft: false, module: 'order', menu: 'order' }},
      { path: 'order/index/:status', component: orderIndex, name: 'orderIndex', meta: { hideLeft: false, module: 'order', menu: 'order' }}
    ]
  },
  {
    path: '/index',
    component: ctrlRecharge,
    children: [
      { path: 'ctrl/recharge', component: ctrlRecharge, name: 'ctrlRecharge', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: rot_orderIndex,
    children: [
      { path: 'rot_order/index', component: rot_orderIndex, name: 'rot_orderIndex', meta: { hideLeft: false, module: 'rot_order', menu: 'rot_order' }} 
    ]
  },
  {
    path: '/index',
    component: ctrlTrc20,
    children: [
      { path: 'ctrl/trc20', component: ctrlTrc20, name: 'ctrlTrc20', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: myTrc20,
    children: [
      { path: 'my/trc20', component: myTrc20, name: 'myTrc20', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: myBind_trc20,
    children: [
      { path: 'my/bind_trc20', component: myBind_trc20, name: 'myBind_trc20', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: myBind_bank,
    children: [
      { path: 'my/bind_bank', component: myBind_bank, name: 'myBind_bank', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: myBind_ban_book,
    children: [
      { path: 'my/bind_bank_book', component: myBind_ban_book, name: 'myBind_ban_book', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: ctrlUsdt,
    children: [
      { path: 'ctrl/usdt', component: ctrlUsdt, name: 'ctrlUsdt', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: myYhk,
    children: [
      { path: 'my/yhk', component: myYhk, name: 'myYhk', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: myInvite,
    children: [
      { path: 'my/invite', component: myInvite, name: 'myInvite', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: ctrlEdit_pwd,
    children: [
      { path: 'ctrl/edit_pwd', component: ctrlEdit_pwd, name: 'ctrlEdit_pwd', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: ctrlEdit_pwd2,
    children: [
      { path: 'ctrl/edit_pwd2', component: ctrlEdit_pwd2, name: 'ctrlEdit_pwd2', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: ctrlJunior,
    children: [
      { path: 'ctrl/junior', component: ctrlJunior, name: 'ctrlJunior', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: ctrlSet,
    children: [
      { path: 'ctrl/set', component: ctrlSet, name: 'ctrlSet', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: ctrlRecharge_admin,
    children: [
      { path: 'ctrl/recharge_admin', component: ctrlRecharge_admin, name: 'ctrlRecharge_admin', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: ctrlDeposit_admin,
    children: [
      { path: 'ctrl/deposit_admin', component: ctrlDeposit_admin, name: 'ctrlDeposit_admin', meta: { hideLeft: false, module: 'ctrl', menu: 'ctrl' }}
    ]
  },
  {
    path: '/index',
    component: myCaiwu,
    children: [
      { path: 'my/caiwu', component: myCaiwu, name: 'myCaiwu', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },
  {
    path: '/index',
    component: myDetail,
    children: [
      { path: 'my/detail', component: myDetail, name: 'myDetail', meta: { hideLeft: false, module: 'my', menu: 'my' }},
      { path: 'my/detail/:id', component: myDetail, name: 'myDetail', meta: { hideLeft: false, module: 'my', menu: 'my' }}
    ]
  },



]

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})

router.beforeEach(async(to, from, next) => {
  const hideLeft = to.meta.hideLeft
  store.dispatch('showLeftMenu', hideLeft)
  // console.log('---index.js to.name---');
  // console.log(to.name);
  // 如果跳转去登录页
  if (to.name !== 'Login' && to.name !== 'Lang' && to.name !== 'Register') {
    const expire = Lockr.get('expire')
    const advanceTime = config.advanceTime
    const nowTime = Math.floor(new Date().getTime() / 1000)
    const infos = baseHttp.apiPost('index/infos/index')
    const quees = [infos]
    // console.log('---nowTime---');
    // console.log(nowTime);
    // console.log('---expire---');
    // console.log(expire);
    // console.log('---advanceTime---');
    // console.log(advanceTime);
    if (nowTime >= (expire - advanceTime)) {
      const refresh = baseHttp.apiPost('index/infos/refresh') // 获取新token
      quees.push(refresh)
    }
    const result = await Promise.all(quees)
    // console.log('---index.js result---');
    // console.log(result);
    // if (to.name == 'indexMain'){
    //   Lockr.set('currentUrl', 'index/index/home')
    // }
    // 如果请求多于1个（获取用户信息）
    if (result.length >= 1) {
      if (result[0].code === 200) {
        // result[0].data.menus[0].url = "/index/index/home";
        const data = result[0].data
        // store.dispatch('setMenus', data.menus)      // 菜单信息
        // store.dispatch('setRules', data.authList)       // 权限信息
        store.dispatch('setUsers', data.userInfo)       // 用户信息
      } else {
        _g.toastMsg('warning', 'Please log in again')
        setTimeout(() => {
          router.replace('/')
        }, 1500)
        return
      }
    };
    // 如果请求多于2个(获取用户信息，刷新token)
    if (result.length >= 2) {
      if (result[0].code === 200) {
        const data = result[1].data
        Lockr.set('authKey', data.authKey)              // 权限认证
        Lockr.set('expire', data.expire)              // 权限认证
      } else {
        _g.toastMsg('warning', 'Please log in again')
        setTimeout(() => {
          router.replace('/')
        }, 1500)
        return
      }
    }
  }
  NProgress.start()
  next()
})

router.afterEach(transition => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js